import { Workbox } from "workbox-window";

const SW_URL = "/sw.js";
const SW_SCOPE = "/";
const SW_DISMISS_KEY = "ownerflow-sw-update-dismissed";

let workbox: Workbox | null = null;

export function getServiceWorkerRegistration(): Promise<ServiceWorkerRegistration | null> {
  if (!("serviceWorker" in navigator)) return Promise.resolve(null);
  return navigator.serviceWorker.getRegistration(SW_SCOPE).then((reg) => reg ?? null);
}

function watchForNewUpdates(registration: ServiceWorkerRegistration) {
  registration.addEventListener("updatefound", () => {
    const installing = registration.installing;
    if (!installing) return;

    installing.addEventListener("statechange", () => {
      if (installing.state === "installed" && registration.waiting) {
        sessionStorage.removeItem(SW_DISMISS_KEY);
      }
    });
  });
}

function promptForUpdate(wb: Workbox) {
  if (sessionStorage.getItem(SW_DISMISS_KEY) === "1") return;

  const shouldUpdate = window.confirm(
    "Une nouvelle version OwnerFlow est disponible. Mettre à jour maintenant ?",
  );

  if (shouldUpdate) {
    sessionStorage.removeItem(SW_DISMISS_KEY);
    wb.messageSkipWaiting();
    return;
  }

  sessionStorage.setItem(SW_DISMISS_KEY, "1");
}

export function registerOwnerFlowServiceWorker(): Workbox | null {
  if (!("serviceWorker" in navigator)) return null;
  if (import.meta.env.DEV) {
    const cleared = "ownerflow-vite-sw-cleared";
    if (!sessionStorage.getItem(cleared)) {
      sessionStorage.setItem(cleared, "1");
      void navigator.serviceWorker.getRegistrations().then((regs) => {
        for (const reg of regs) void reg.unregister();
      });
    }
    return null;
  }
  if (workbox) return workbox;

  workbox = new Workbox(SW_URL, { scope: SW_SCOPE });

  workbox.addEventListener("waiting", () => {
    promptForUpdate(workbox!);
  });

  workbox.addEventListener("controlling", () => {
    sessionStorage.removeItem(SW_DISMISS_KEY);
    window.location.reload();
  });

  void workbox.register().then((registration) => {
    if (registration) watchForNewUpdates(registration);
  });

  return workbox;
}
